<template>
  <DatePickerPopupContainer
    :date-picker="datePicker"
    @move-year-month="onMoveCalendarButtonClick"
  >
    <CalendarDateRangeTable
      v-for="calendar in calendars"
      :key="calendar.month"
      class="dateRangePickerPopup__calendar"
      :calendar="calendar"
      :selected-period="selectedPeriod"
      :enabled-period="enabledPeriod"
      @select-date="onSelectDate"
      @mouse-enter-date="onMouseEnterDate"
    />
  </DatePickerPopupContainer>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { DatePicker } from "@/models/date-picker/DatePicker";
import { Calendar } from "@/models/date-picker/Calendar";
import { DateRange } from "@/components/date-picker/DateRange";
import DatePickerPopupContainer from "@/components/date-picker/popup/DatePickerPopupContainer.vue";
import CalendarDateRangeTable from "@/components/date-picker/calendar/CalendarDateRangeTable.vue";

@Component({
  components: { DatePickerPopupContainer, CalendarDateRangeTable }
})
export default class DateRangePickerPopup extends Vue {
  @Prop({ type: DatePicker, required: true })
  datePicker!: DatePicker;

  @Prop({ type: Object, default: null })
  selectedPeriod!: DateRange;

  @Prop({ type: Object, default: null })
  enabledPeriod!: DateRange;

  onSelectDate(date: Date) {
    this.$emit("select-date", date);
  }

  onMouseEnterDate(date: Date) {
    this.$emit("mouse-enter-date", date);
  }

  onMoveCalendarButtonClick(calender: Calendar) {
    this.$emit("move-year-month", calender);
  }

  get calendars(): Calendar[] {
    return this.datePicker.calendars;
  }
}
</script>

<style scoped lang="scss">
.dateRangePickerPopup__calendar {
  width: 33.3%;

  &:not(:first-child) {
    margin-left: 20px;
  }
}
</style>
